  <!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<ng-container *ngIf="legalEntities | async as legalEntitiesResource">
    <div *ngFor="let legalEntity of legalEntitiesResource?.data">
      <well-legal-entity-card-view [legalEntity]="legalEntity"></well-legal-entity-card-view>
    </div>

  </ng-container>



